import React from 'react';
import Page from '../layouts/main';

function ErrorPage() {
  return (
    <Page>
      <div className="grid-x grid-container">
        <div className="cell small-12">
          <h1 className="error-header">Page Not Found</h1>
          <div className="grid-x grid-container">
            <div className="cell small-12 medium-6"><h3 className="error-code">404</h3></div>
            <div className="cell small-12 medium-6">
              <p className="error-text">Drats! Looks like you took a wrong turn onto a page that isn&apos;t here.</p>
              <p className="error-text">But wait! I&apos;m sure what you were looking for is here. If you got here from clicking a link, that page may have moved, so try one of the big tabs up top to get back on track.</p>
              <p className="error-text">
                If you continue having problems, feel free to
                {' '}
                <a href="mailto:support@roadtripnation.com">
                  shoot us an email
                </a>
                {' '}
                and we&apos;ll get right back atcha. Thanks for your patience!
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default ErrorPage;
